<div class="card h-100">
  <div class="card-header">
    <h3>{{ 'accessibility_health' | translate }}</h3>
  </div>
  <div class="card-body h-100 d-flex justify-content-center align-items-center">
    <app-scan-health-chart
      class="w-100"
      [scanSummary]="scanSummary"
      [previousScanSummary]="previousScanSummary"
    ></app-scan-health-chart>
  </div>
</div>
